export default "__VITE_ASSET__BQIb5azt__"